<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

        <!-- 左边 -->
        <!-- <div style="margin:5px;float:right">
                <el-button size="mini" type="success" @click="openModel">添加项目</el-button>
            </div> -->

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="name" label="项目名称" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="status_text" label="项目状态" show-overflow-tooltip align="center">
            </el-table-column>
            <!-- <el-table-column prop="name" label="项目名称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="name" label="项目名称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="name" label="项目名称" show-overflow-tooltip align="center"></el-table-column> -->
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <el-button @click="setupClick(scope.row)" type="primary" size="mini">设置</el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <div style="float:right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>

        <el-dialog :title="names" :visible.sync="dialogVisible" top='20px'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="项目名称">
                        <el-input v-model="ruleForm.project" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="项目状态">
                        <el-select v-model="ruleForm.status" placeholder="请选择" size="small" style="width:30%">
                            <el-option v-for="item in status_options" :key="item.id" :label="item.content_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="图片">
                        <div>
                            <span v-if="!ruleForm.avatar" class="btn btn-light border mr-2" @click="chooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <img v-else :src="ruleForm.avatar" class="rounded"
                                style="width: 100px;height: 100px;cursor: pointer;" @click="chooseImage" />
                        </div>
                    </el-form-item>
                    <el-form-item label="关键词:">
                        <div style="display: flex;flex-direction: column;">
                            <span style="color:red">多个关键词请换行隔开</span>
                            <el-input type="textarea" v-model="ruleForm.ReceivingAddress" :rows="5" style="width:50%">
                            </el-input>
                        </div>

                    </el-form-item>
                    <el-form-item label="联系方式">
                        <el-input v-model="ruleForm.tel" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="总高">
                        <el-input v-model="ruleForm.floor_high" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="建筑面积">
                        <el-input v-model="ruleForm.land" placeholder="请输入内容" style="width:50%"></el-input><span
                            style="font-size:20px">/m²</span>
                    </el-form-item>
                    <el-form-item label="床位">
                        <el-input v-model="ruleForm.bed_num" placeholder="请输入内容" style="width:50%"></el-input>
                    </el-form-item>
                    <el-form-item label="入住率">
                        <el-input v-model="ruleForm.enter_lv" placeholder="请输入内容" style="width:50%"></el-input><span
                            style="font-size:20px">%</span>
                    </el-form-item>
                    <el-form-item label="公共空间">
                        <el-input v-model="ruleForm.public_space" placeholder="请输入内容" style="width:50%"></el-input><span
                            style="font-size:20px">/m²</span>
                    </el-form-item>
                    <el-form-item label="地址">
                        <el-select v-model="ruleForm.sf_id" placeholder="请选择省份" size="small" @change="getsq"
                            style="width:30%">
                            <el-option v-for="item in sf_options" :key="item.code" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                        <el-select v-model="ruleForm.sq_id" placeholder="请选择城市" size="small" clearable @change="getqy"
                            style="width:30%">
                            <el-option v-for="item in sq_options" :key="item.code" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                        <el-select v-model="ruleForm.qy_id" placeholder="请选择区域" size="small" clearable @change="getjd"
                            style="width:30%">
                            <el-option v-for="item in qy_options" :key="item.code" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                        <el-select v-model="ruleForm.jd_id" placeholder="请选择街道" size="small" clearable
                            style="width:30%">
                            <el-option v-for="item in jd_options" :key="item.code" :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="详细地址">
                        <el-input v-model="ruleForm.detailed" placeholder="请输入内容" style="width:70%"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                <el-button @click="subForm" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="设置" :visible.sync="dialogVisibles" width="70%" style="margin-top:-80px">
            <div class="dialog-ibox-content">
                <el-tabs v-model="activeName" type="card" @tab-click="szClick">
                    <el-tab-pane label="院区楼栋" name="ld"></el-tab-pane>
                    <el-tab-pane label="院区房型" name="fxx"></el-tab-pane>
                    <el-tab-pane label="院区房间" name="fx"></el-tab-pane>
                    <!-- <el-tab-pane label="院区活动" name="yqhd"></el-tab-pane> -->
                    <el-tab-pane label="院区视频" name="sp"></el-tab-pane>
                    <el-tab-pane label="院区风采" name="fc"></el-tab-pane>
                    <el-tab-pane label="院区详情" name="xq"></el-tab-pane>
                   
                    <!-- <el-tab-pane label="院区楼层" name="lc"></el-tab-pane> -->
                    
                </el-tabs>
                <div v-if="activeName =='fx'">
                    <fx :operateProjectId="operateProjectId"></fx>
                </div>
                <div v-if="activeName =='fxx'">
                    <fxx :operateProjectId="operateProjectId"></fxx>
                </div>
                <!-- <div v-if="activeName =='yqhd'"><yqhd :operateProjectId="operateProjectId"></yqhd></div> -->
                <div v-if="activeName =='sp'">
                    <sp :operateProjectId="operateProjectId"></sp>
                </div>
                <div v-if="activeName =='fc'">
                    <fc :operateProjectId="operateProjectId"></fc>
                </div>
                <div v-if="activeName =='xq'">
                    <xq :operateProjectId="operateProjectId"></xq>
                </div>
                <!-- <div v-if="activeName =='lc'">
                    <lc :operateProjectId="operateProjectId"></lc>
                </div> -->
                <div v-if="activeName =='ld'">
                    <ld :operateProjectId="operateProjectId"></ld>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibles = false" size='small'>取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue"
    import common from '@/common/mixins/common.js';
    import fx from '@/components/project/fx.vue';
    import fxx from '@/components/project/fxx.vue';
    import yqhd from '@/components/project/yqhd.vue';
    import sp from '@/components/project/sp.vue';
    import fc from '@/components/project/fc.vue';
    import xq from '@/components/project/xq.vue';
    import lc from '@/components/project/lc.vue';
    import ld from '@/components/project/ld.vue';
    export default {
        inject: ['app', 'layout'],
        mixins: [common],
        components: {
            buttonSearch,
            fx,
            fxx,
            yqhd,
            sp,
            fc,
            xq,
            lc,
            ld,
        },
        data() {
            return {
                namenc: false,
                names: '',
                activeName: 'ld',
                pageSize: 15,
                curPage: 1,
                count: 0,
                status_options: [],
                jd_options: [],
                sf_options: [],
                sq_options: [],
                qy_options: [],
                jd_optionss: [],
                sf_optionss: [],
                sq_optionss: [],
                qy_optionss: [],
                tableData: [],
                loadings: false,
                height: null,
                dialogVisible: false,
                ruleForm: {
                    project: '',
                    status: '',
                    avatar: '',
                    ReceivingAddress: '',
                    land: '',
                    sf_id: '',
                    sq_id: '',
                    qy_id: '',
                    detailed: '',
                    jd_id: '',
                    enter_lv:'',
                    bed_num:'',
                    public_space:'',
                    tel:'',
                    floor_high:''
            
                },
                rules: {},
                dialogVisibles: false,
                ruleForms: {
                    project: '',
                    status: '',
                    avatar: '',
                    ReceivingAddress: '',
                    land: '',
                    sf_id: '',
                    sq_id: '',
                    qy_id: '',
                    detailed: '',
                    jd_id: ''
                },
                rule: {},
                eid: '',
                // 操作项目的id
                operateProjectId: null,
            }
        },
        computed: {

        },
        mounted() {
            let that = this
            that.search()
            that.all_sheng()
            that.getzt()
        },
        methods: {
            search() {
                let that = this
                axios
                    .post("/admin/lgProject/index", {
                        limit: that.pageSize,
                        page: that.curPage,
                    }, {
                        token: true
                    })
                    .then(response => {
                        // console.log(response.data.data.data);
                        that.tableData = response.data.data.data
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
             handleSizeChange(val){
                let that = this
                that.pageSize = val
                that.search()
            },
            handleCurrentChange(val){
                 let that = this
                that.curPage = val
                that.search()
            },
            getzt() {
                let that = this
                axios
                    .post("/admin/DictionaryModel/RightList", {
                        source: "content",
                        sys_id: 2,
                        type_id: 3
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.status_options = response.data.data
                    })
                    .catch(error => {})
            },
            all_sheng() {
                let that = this
                axios
                    .post("/admin/Area/getProvince_vue", {}, {
                        token: true
                    })
                    .then(response => {
                        that.sf_options = response.data.data
                    })
                    .catch(error => {})
            },
            getsq() {
                let that = this
                that.sq_options = []
                that.ruleForm.sq_id = ''
                that.qy_options = []
                that.ruleForm.qy_id = ''
                axios
                    .post("/admin/Area/getChild_vue", {
                        parentcode: that.ruleForm.sf_id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.sq_options = response.data.data


                    })
                    .catch(error => {})
            },
            getqy() {
                let that = this
                axios
                    .post("/admin/Area/getChild_vue", {
                        parentcode: that.ruleForm.sq_id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.qy_options = response.data.data

                    })
                    .catch(error => {})

            },
            getjd() {
                let that = this
                axios
                    .post("/admin/Area/getChild_vue", {
                        parentcode: that.ruleForm.qy_id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.jd_options = response.data.data
                    })
                    .catch(error => {})
            },

            openModel() {
                let that = this
                that.dialogVisible = true
                that.names = '新增'
                that.namenc = true
                that.ruleForm.project = ''
                that.ruleForm.status = ''
                that.ruleForm.avatar = ''
                that.ruleForm.ReceivingAddress = ''
                that.ruleForm.land = ''
                that.ruleForm.enter_lv = ''
                that.ruleForm.bed_num = ''
                that.ruleForm.public_space = ''
                that.ruleForm.sf_id = ''
                that.ruleForm.sq_id = ''
                that.ruleForm.qy_id = ''
                that.ruleForm.jd_id = ''
                that.ruleForm.detailed = ''
                that.ruleForm.tel = ''
                that.ruleForm.floor_high = ''
            },
            subForm() {
                let that = this

                var arrs = that.ruleForm.ReceivingAddress.split("\n");
                if(that.namenc == true){
                     axios
                    .post("/admin/lgProject/Madd", {
                        // id: that.namenc == true ? 0 : that.eid,
                        name: that.ruleForm.project,
                        keywords: arrs,
                        main_pic: that.ruleForm.avatar,
                        jzmj: that.ruleForm.land,
                        tel:that.ruleForm.tel,
                        floor_high: that.ruleForm.floor_high,
                        status: that.ruleForm.status,
                        province: that.ruleForm.sf_id,
                        city: that.ruleForm.sq_id,
                        area: that.ruleForm.qy_id,
                        street: that.ruleForm.jd_id,
                        address: that.ruleForm.detailed,
                        public_space:that.ruleForm.public_space,
                        enter_lv:that.ruleForm.enter_lv,
                        bed_num:that.ruleForm.bed_num,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == 200) {
                            this.$message({
                                showClose: true,
                                type: 'success',
                                message: response.data.msg

                            });
                            that.dialogVisible = false
                            that.search()
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.data.msg,
                                type: 'error'
                            });
                        }
                    })
                    .catch(error => {})
                }
                if(that.namenc != true){
                     axios
                    .post("/admin/lgProject/Medit", {
                        id: that.eid,
                        name: that.ruleForm.project,
                        keywords: arrs,
                        main_pic: that.ruleForm.avatar,
                        jzmj: that.ruleForm.land,
                        tel:that.ruleForm.tel,
                        floor_high: that.ruleForm.floor_high,
                        status: that.ruleForm.status,
                        province: that.ruleForm.sf_id,
                        city: that.ruleForm.sq_id,
                        area: that.ruleForm.qy_id,
                        street: that.ruleForm.jd_id,
                        address: that.ruleForm.detailed,
                        public_space:that.ruleForm.public_space,
                        enter_lv:that.ruleForm.enter_lv,
                        bed_num:that.ruleForm.bed_num,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == 200) {
                            this.$message({
                                showClose: true,
                                type: 'success',
                                message: response.data.msg

                            });
                            that.dialogVisible = false
                            that.search()
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.data.msg,
                                type: 'error'
                            });
                        }
                    })
                    .catch(error => {})
                }
               
            },
            // 选择图片
            chooseImage() {
                this.app.chooseImage((res) => {
                    this.ruleForm.avatar = res[0].url
                }, 1)
            },
            editGetCityOPtion() {
                that.getsq()
            },
            //编辑
            async handleClick(row) {
                let that = this
                that.ruleForm.sf_id = row.province
                that.ruleForm.sq_id = row.city
                that.ruleForm.qy_id = row.area
                that.ruleForm.jd_id = row.street



                let ReceivingAddress = Object.values(row.keywords);
                that.dialogVisible = true
                that.names = '编辑'
                that.namenc = false
                that.ruleForm.project = row.name
                that.ruleForm.status = row.status
                that.ruleForm.avatar = row.main_pic
                that.ruleForm.ReceivingAddress = ReceivingAddress.join("\n");
                that.ruleForm.land = row.jzmj
                that.ruleForm.tel = row.tel
                that.ruleForm.floor_high = row.floor_high
                that.ruleForm.public_space = row.public_space
                that.ruleForm.enter_lv = row.enter_lv
                that.ruleForm.bed_num = row.bed_num
                that.ruleForm.detailed = row.address
                that.eid = row.id
            },

            setupClick(row) {
                let that = this
                that.operateProjectId = row.id;
                that.dialogVisibles = true

            },
            szClick() {

            },
        },
    }
</script>

<style>
</style>